export enum OrganizationConfigKey {
  SHOPIFY_STORE = 'SHOPIFY_STORE',
  SHOPIFY_STORE_ACCESS_TOKEN = 'SHOPIFY_STORE_ACCESS_TOKEN',
  SHOPIFY_STORE_INV_LOCATION = 'SHOPIFY_STORE_INV_LOCATION',
  STORE_LOGO_URL = 'STORE_LOGO_URL',
  CC_EMAIL = 'CC_EMAIL',
  CC_PHONE = 'CC_PHONE',
  GSTIN = 'GSTIN',
  PAN = 'PAN',
  GST_NAME = 'GST_NAME',
  GST_ADDRESS = 'GST_ADDRESS',
}

interface OrgConfigKeyValuePair {
  [key: string]: any; // The value can be of any type
}

export interface IOrganization {
  id: number;
  name: string;
  config: OrgConfigKeyValuePair;
}
